/**
 * SkillCard
 * 
 * Displays a single skill with icon, name, and description
 */

import { memo } from 'react';
import { Skill } from '../types';
import styles from './skill-card.module.css';

export interface SkillCardProps {
  skill: Skill;
  isLocked?: boolean;
  onClick?: () => void;
}

export const SkillCard = memo(({ skill, isLocked = false, onClick }: SkillCardProps) => {
  return (
    <div 
      className={`${styles.skillCard} ${isLocked ? styles.locked : ''} ${onClick ? styles.clickable : ''}`} 
      onClick={onClick}
      role={onClick ? "button" : "article"}
      tabIndex={onClick ? 0 : undefined}
      aria-label={isLocked ? "Locked skill" : `${skill.name}: ${skill.description}`}
    >
      <div className={styles.skillIcon} aria-hidden="true">
        {!isLocked && skill.icon ? (
          <img src={skill.icon} alt="" />
        ) : (
          <span>{isLocked ? '🔒' : '🎯'}</span>
        )}
      </div>
      <div className={styles.skillName}>
        {isLocked ? '???' : skill.name}
      </div>
      <div className={styles.skillDescription}>
        {isLocked ? '???' : skill.description}
      </div>
    </div>
  );
});
